import { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import Button from "../../components/common/button/Button";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import Input from "./../../components/common/inputs/Input";
import CategoriesSelect from "../../components/common/inputs/CategoriesSelect";
import ProductOption from "./sub-components/product/product-option/ProductOption";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import ProductImages from "./sub-components/product/product-images/ProductImages";
import { productValidation } from "../../utils/validation/prodcut/productValidation";
import ProductFeature from "./sub-components/product/product-feature/ProductFeature";
import SliderTageSelect from "../../components/common/inputs/SliderTageSelect";
import TextArea from "../../components/common/inputs/TextArea";
import Editor from "../../components/common/ck-editor/CkEditor";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import ProductsPack from "./sub-components/product/products-pack/ProductsPack";
import CategoryPartType from "../../components/common/inputs/CategoryPartTypeSelect";
import { convertDate } from "../../utils/convertDate";
import DateInput from "../../components/common/inputs/DateInput";

export default function Product() {
  const location = useLocation();
  const navigate = useNavigate();

  const [description, setDescription] = useState("");
  const [categoryPartTypes, setCategoryPartType] = useState([]);
  const [discountExpireDate, setDiscountExpireDate] = useState(
    location.state?.discountExpireDate
  );

  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
      categoryPartTypes,
      selectedBooth: values.selectedBooth === "1",
      basePrice: Number(values.basePrice),
      buyPrice: Number(values.buyPrice),
      discount: Number(values.discount),
      categories,
      features,
      option: option ? option : undefined,
      bundleProducts: packItem?.length ? packItem : undefined,
      images,
      stock: option ? undefined : Number(values?.stock),
      limitStock: option ? undefined : Number(values?.limitStock),
      mainImage,
      discountType,
      sliderTags: sliderTags.filter((tag) => tag !== "DONE_AKHARI"),
      description,
      discountExpireDate,
    };
    if (
      discountType !== "percent" ||
      (discountType == "percent" && body.discount <= 100)
    ) {
      try {
        if (location?.state) {
          const response = await putApi({
            path: `admin/products/${location?.state?._id}`,
            body: JSON.stringify(body),
          });
          console.log(response);
          successMessage("محصول با موفقیت ویرایش شد");
        } else {
          const response = await postApi({
            path: "admin/products",
            body: JSON.stringify(body),
          });
          console.log(response);
          successMessage("محصول با موفقیت اضافه شد");
        }
        resetForm();
        setOption(null);
        reset();
        navigate("/product-list");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("درصد تخفیف نمیتواند بیشتر از 100 باشد");
    }
  };

  const [option, setOption] = useState(null);
  const [features, setFeatures] = useState(null);
  const [isPack, setIsPack] = useState(false);

  const [images, setImages] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [discountType, setDiscountType] = useState(
    location.state?.discountType || "price"
  );
  const [oldOptions, setOldOptions] = useState([]);
  const [oldImages, setOldImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [oldFeatures, setOldFeatures] = useState([]);

  const [sliderTags, setSliderTags] = useState([]);
  const [packItem, setPackItem] = useState([]);

  useEffect(() => {
    if (location.state) {
      setOldOptions(location.state.option || []);
      console.log(location.state.option || []);
      if (location.state.images?.length > 0) {
        let newImages = location.state.images.map((item) => {
          if (item == location.state.mainImage) {
            return { name: item, isMain: true };
          } else {
            return {
              name: item,
              isMain: false,
            };
          }
        });
        setOldImages(newImages);
        setImages(location?.state?.images || []);
      }
      if (location?.state?.mainImage) {
        setMainImage(location?.state?.mainImage || "");
      }
      if (location?.state?.option) {
        setOption(location?.state?.option || {});
      }
      if (location?.state?.features?.length) {
        setOldFeatures(location?.state?.features || []);
        setFeatures(location?.state?.features || []);
      }
      if (location?.state?.categories?.length) {
        setCategories(location?.state?.categories || []);
      }
      if (location?.state?.sliderTags?.length) {
        setSliderTags(location?.state?.sliderTags || []);
      }
      if (location?.state?.bundleProducts?.length) {
        setPackItem(location?.state?.bundleProducts || []);
        setIsPack(true);
      }
    }
  }, [location.state]);
  const productOptionRef = useRef();

  const handle = (data) => {
    console.log(data);
    setOption(data);
  };

  const handleFeatures = (data) => {
    console.log(data);
    setFeatures(data);
  };

  const categoryRef = useRef();
  const imagesRef = useRef();
  const packRef = useRef();
  const basePriceRef = useRef();
  const discountRef = useRef();
  const featuresRef = useRef();
  const sliderTagsRef = useRef();
  const buyPriceRef = useRef();

  console.log(location.state);

  const handleImages = (data) => {
    if (data?.length) {
      const mainImage = data.filter((item) => {
        return item.isMain == true;
      });
      setMainImage(mainImage[0].name);

      const allImages = data.map((item) => {
        return item.name;
      });
      setImages(allImages);
    } else {
      setMainImage("");
      setImages([]);
    }
  };

  const handlePack = (data) => {
    setPackItem(data);
  };

  useEffect(() => {
    if (location.pathname == "/add-product") {
      reset();
    }
  }, [location.pathname]);
  const categoryPartTypesRef = useRef();

  const reset = () => {
    categoryRef.current.afterSubmit();
    productOptionRef.current.afterSubmit();
    imagesRef.current.afterSubmit();
    setOldImages([]);
    setOldOptions([]);
    basePriceRef.current.afterSubmit();
    discountRef.current.afterSubmit();
    featuresRef.current.afterSubmit();
    sliderTagsRef.current.afterSubmit();
    categoryPartTypesRef.current.afterSubmit();
  };
  const copyImagesUrlModal = useRef();

  const handleIsPack = () => {
    if (!isPack) {
      setPackItem(null);
    } else {
      setOption(null);
      setOldOptions(null);
    }
    setIsPack(!isPack);
  };

  return (
    <AdminFormLayout title={location.state ? "ویرایش محصول" : "افزودن محصول"} description="مشخصات، قیمت و موجودی محصول را در بخش‌های زیر مدیریت کنید.">
      <div className="mt-6">
        <Formik
          enableReinitialize
          initialValues={{
            name: location?.state?.name || "",
            status: location?.state?.status || "active",
            shortDescription: location?.state?.shortDescription || "",
            seoContent: location?.state?.seoContent || "",
            seoTitle: location?.state?.seoTitle || "",
            basePrice: location?.state?.basePrice || "",
            stock: location?.state?.stock || "",
            limitStock: location?.state?.limitStock || "",
            checkStock: location?.state?.checkStock || false,
            buyPrice: location?.state?.buyPrice || "",
            discount:
              location?.state?.discountType === "price"
                ? location?.state?.discountPrice
                : location?.state?.discountPercent || "",
            inventoryStatus: location?.state?.inventoryStatus || "available",
            selectedBooth: location?.state?.selectedBooth ? "1" : "0",
          }}
          validationSchema={productValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <FormSection title="مشخصات اصلی" description="نامی روشن و قابل جستجو برای محصول انتخاب کنید.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام محصول را وارد کنید" label="نام محصول" type="text" />
              </div>
              </FormSection>
              <FormSection title="قیمت‌گذاری و تخفیف" description="قیمت‌ها را مطابق واحد پول فروشگاه وارد کنید. تخفیف درصدی نباید بیشتر از ۱۰۰ باشد.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <div>
                  <label
                    htmlFor="basePrice"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت پایه
                  </label>
                  <CurrencyInput
                    placeholder="قیمت پایه"
                    name="basePrice"
                    id="basePrice"
                    ref={basePriceRef}
                    inputValue={formik.values.basePrice}
                    onChange={(e) => formik.setFieldValue("basePrice", e)}
                  />
                  {formik.errors.basePrice && formik.touched.basePrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.basePrice}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label
                    htmlFor="buyPrice"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت خرید
                  </label>
                  <CurrencyInput
                    placeholder="قیمت خرید"
                    name="buyPrice"
                    id="buyPrice"
                    ref={buyPriceRef}
                    inputValue={formik.values.buyPrice}
                    onChange={(e) => formik.setFieldValue("buyPrice", e)}
                  />
                  {formik.errors.buyPrice && formik.touched.buyPrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.buyPrice}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label htmlFor="discountType" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تخفیف
                  </label>
                  <select
                    id="discountType"
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"percent"}>درصد</option>
                    <option value={"price"}>قیمت</option>
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="discount"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    تخفیف
                  </label>
                  <CurrencyInput
                    placeholder="تخفیف"
                    ref={discountRef}
                    name="discount"
                    inputValue={formik.values["discount"]}
                    onChange={(e) => formik.setFieldValue("discount", e)}
                  />
                  {formik.errors.discount && formik.touched.discount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.discount}
                    </p>
                  ) : null}
                </div>
                <DateInput
                  label={`مقدار فعلی تاریخ انقضا ${
                    discountExpireDate
                      ? convertDate(discountExpireDate, true)
                      : "ندارد"
                  }`}
                  onChange={setDiscountExpireDate}
                />
              </div>
              </FormSection>
              <FormSection title="دسته‌بندی و نمایش" description="محل نمایش محصول و وضعیت انتشار آن را مشخص کنید.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <CategoriesSelect
                  label={"دسته بندی "}
                  oldCategory={location?.state?.categories}
                  ref={categoryRef}
                  onChange={setCategories}
                />
                <Select name="status" placeholder="وضعیت" label="وضعیت">
                  <option value={"active"}>فعال</option>
                  <option value={"pending"}>در حال بررسی</option>
                  <option value={"inactive"}>غیر فعال</option>
                </Select>

                <div>
                <SliderTageSelect
                  label={"تگ‌های نمایش در اسلایدر "}
                  oldSliderTags={sliderTags}
                  ref={sliderTagsRef}
                  onChange={setSliderTags}
                />
                <p className="admin-field-hint">
                  نمایش در «دونه آخری» خودکار است و تگ دستی نمی‌خواهد: محصول فعال و موجود با کنترل موجودی و دقیقاً یک عدد قابل خرید. برای محصول متنوع، مجموع موجودی تنوع‌های قابل خرید ملاک است. پک‌ها در این بخش نمایش داده نمی‌شوند.
                </p>
                </div>
                <CategoryPartType
                  label={"دسته بندی بخش"}
                  oldData={location?.state?.categoryPartTypes}
                  ref={categoryPartTypesRef}
                  placeholder="انتخاب"
                  onChange={setCategoryPartType}
                />
                <Select
                  name="selectedBooth"
                  placeholder="غرفه منتخب"
                  label="غرفه منتخب"
                >
                  <option value={"0"}>خیر</option>
                  <option value={"1"}>بله</option>
                </Select>
              </div>
              </FormSection>
              <FormSection title="موجودی و محدودیت خرید" description="برای محصولات دارای تنوع، موجودی هر تنوع از بخش تنوع محصول مدیریت می‌شود.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Select
                  name="inventoryStatus"
                  placeholder="موجودی"
                  label="موجودی"
                >
                  <option value={"available"}>موجود</option>
                  <option value={"unavailable"}>نا موجود</option>
                </Select>

                {option ? null : (
                  <Input
                    name="stock"
                    placeholder="موجودی انبار"
                    label="موجودی انبار"
                    type="text"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                )}
                {option ? null : (
                  <Input
                    name="limitStock"
                    placeholder="محدودیت"
                    label="محدودیت"
                    type="text"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                )}

                <Select
                  name="checkStock"
                  value={formik.values["checkStock"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "checkStock",
                      e.target.value === "true"
                    );
                  }}
                  placeholder="بررسی موجودی انبار"
                  label="بررسی موجودی انبار"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>
              </div>

              </FormSection>
              <FormSection title="توضیحات و محتوا" description="توضیحات کوتاه برای معرفی سریع و متن کامل برای صفحه جزئیات استفاده می‌شود.">
              <div className="flex flex-col gap-3">
                <TextArea
                  name="shortDescription"
                  placeholder="توضیحات کوتاه"
                  label="توضیحات کوتاه"
                  type="text"
                />
                <TextArea
                  name="seoContent"
                  placeholder="محتوای سئو"
                  label="محتوای سئو"
                  type="text"
                />
                <TextArea
                  name="seoTitle"
                  placeholder="تیتر سئو"
                  label="تیتر سئو"
                  type="text"
                />
              </div>
              <div className="mt-4">
                <Button
                  type="button"
                  onClick={() => copyImagesUrlModal.current.showModal()}
                  text={"انتخاب عکس توضیحات"}
                  color={"primary"}
                  className="mb-3"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <Editor onChange={setDescription} />
              </div>

              </FormSection>
              <FormSection title="تصاویر، ویژگی‌ها و تنوع" description="تصاویر محصول را انتخاب کنید و ویژگی‌ها، تنوع یا اقلام پک را مدیریت کنید.">
              <div className="mt-4">
                <label className="inline-flex items-center cursor-pointer">
                  <span className="me-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                    این محصول یک پک است
                  </span>
                  <input
                    checked={isPack}
                    onChange={handleIsPack}
                    type="checkbox"
                    className="sr-only peer"
                  />
                  <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>

              <div className="admin-form-tools">
                {isPack ? (
                  <button
                    onClick={() => packRef.current.showModal()}
                    type="button"
                    className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                  >
                    محصولات پک
                  </button>
                ) : (
                  <button
                    onClick={() => productOptionRef.current.showModal()}
                    type="button"
                    className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                  >
                    تنوع محصول
                  </button>
                )}

                <button
                  onClick={() => imagesRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                >
                  تصاویر محصول
                </button>
                <button
                  onClick={() => featuresRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                >
                  ویژگی‌های محصول
                </button>
              </div>

              </FormSection>
              <div className="admin-form-actions">
                  <Button
                    text={location.state ? "ذخیره تغییرات" : "ایجاد محصول"}
                    loading={formik.isSubmitting}
                    color={"success"}
                  />
                  <button type="button" className="admin-form-cancel" onClick={() => navigate("/product-list")}>انصراف و بازگشت</button>
              </div>
            </Form>
          )}
        </Formik>
        <ProductImages
          ref={imagesRef}
          handleImages={handleImages}
          oldImages={oldImages}
        />
        <ProductsPack
          ref={packRef}
          handlePack={handlePack}
          oldPack={location?.state?.bundleProducts || []}
        />
        <ProductOption
          ref={productOptionRef}
          handleOption={handle}
          optionData={oldOptions}
        />
        <ProductFeature
          ref={featuresRef}
          handleFeatures={handleFeatures}
          featureData={oldFeatures}
        />
        <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
      </div>
    </AdminFormLayout>
  );
}
